import { UIHeading2 } from '@cian/ui-kit';
import { IconActionFilters16, IconActionSort16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';
import { BX_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT } from '../../constants/experiments';
import { EEntityType } from '../../types/filters';
import { experimentToggle } from '../experimentToggle';

interface IDealTypeFilterIcons {
  entityType: EEntityType | null;
  openSort(): void;
  openFilters(): void;
  isRedesignExperimentActive?: boolean;
  isFiltersEnabled: boolean;
}

export const DealTypeFilterIcons: React.FC<IDealTypeFilterIcons> = ({
  entityType,
  openSort,
  openFilters,
  isRedesignExperimentActive = false,
  isFiltersEnabled,
}) => {
  return (
    <div className={styles['container']}>
      {
        /**
         * @todo experimentToggle - временное решение, удалить после завершения эксперимента aud_mobile_bx585_saved_search_favorites_merge
         */
        experimentToggle(
          isRedesignExperimentActive,
          BX_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT,
          <div className={styles['header']}>Избранное</div>,
          <UIHeading2>Избранное</UIHeading2>,
        )
      }
      {isFiltersEnabled && (
        <div className={styles['controls']}>
          <button onClick={openSort} className={styles['input-link']}>
            <IconActionSort16 color="icon-main-default" />
          </button>
          {entityType !== EEntityType.Newbuilding && (
            <button onClick={openFilters} className={styles['input-link']}>
              <IconActionFilters16 color="icon-main-default" />
            </button>
          )}
        </div>
      )}
    </div>
  );
};
